import {
  Container,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
  FormLabel,
  Radio,
  RadioGroup,
  FormControl,
} from "@mui/material";
import React from "react";

const Comp4PDF = ({
    formData,
}) => {

    const isNoApply =
        formData?.exhibitor_status === "申請しない" &&
        formData?.host_status === "申請しない" &&
        formData?.corporate_status === "申請しない";

  return (
    <Container sx={{ mt: 5, borderRadius: 2, position: 'relative', py: 4, width:'140%' }}>
    <Box>
        <Typography variant="h6">SDGs 子ども・ユースフェア出展者　マイページ情報</Typography>
        {formData ? (
        <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
            <Typography variant="body1">小間番号: {formData?.booth_number}</Typography>
            <Typography variant="body1">出展者名: {formData?.company_name}</Typography>
            <Typography variant="body1">部署: {formData?.department}</Typography>
            <Typography variant="body1">担当者名: {formData?.user_name}</Typography>
            <Typography variant="body1">郵便番号: {formData?.zip_code}</Typography>
            <Typography variant="body1">住所: {formData?.address}</Typography>
            <Typography variant="body1">電話番号: {formData?.phone_number}</Typography>
            <Typography variant="body1">メールアドレス: {formData?.email}</Typography>
        </Box>
        ) : (
        <Typography variant="body2">読み込み中...</Typography>
        )}
    </Box>
    <Box>
        <Typography variant="h6">床面工事施工申込</Typography>
        <FormControlLabel
            control={<Checkbox checked={isNoApply} readOnly />}
            label="申請しない"
        />
        {!isNoApply && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
            <Typography variant="h6" gutterBottom>
            担当者情報
            </Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={formData?.same_ex}>
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
              }}
            >
                <Box>氏名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_4_name}</Box>
                <Box>部署</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_4_department}</Box>
                <Box>会社電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_4_phone}</Box>
                <Box>携帯電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_4_tel}</Box>
            </Box>

            <Typography variant="h6" gutterBottom>
            請求先情報
            </Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={formData?.same_in}>
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
              }}
            >
                <Box>請求先会社名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_company_name}</Box>
                <Box>請求担当者名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_user_name}</Box>
                <Box>請求担メールアドレス</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_email}</Box>
                <Box>郵便番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_zip}</Box>
                <Box>請求先住所</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_address}</Box>
                <Box>電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_tel}</Box>
                <Box>FAX番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_fax}</Box>
            </Box>

            <Typography variant="h6" gutterBottom>
            工事情報
            </Typography>
            <Typography variant="h7" gutterBottom>
            アンカーボルト
            </Typography>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
              }}
            >
                <Box>太さ(mm)</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.bolt_thin}</Box>
                <Box>深さ(mm)</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.bolt_length}</Box>
                <Box>個数</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.bolt_number}</Box>
            </Box>
            <Typography variant="h6">施工業者</Typography>
            <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
            }}
            >
                <Box>社名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.organize_company}</Box>
                <Box>工事責任者</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.organize_name}</Box>
                <Box>郵便番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.organize_zip}</Box>
                <Box>住所</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.organize_address}</Box>
                <Box>電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.organize_tel}</Box>
            </Box>

            <Typography variant="h6">備考欄</Typography>
            <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                        {formData?.alfa_text}
                        </Typography>
        </Box>
        )}
    </Box>
    </Container>
  );
};

export default Comp4PDF;
